import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DataTable, MoneyDisplay, type Column } from '@shared/ui';
import { ROUTES } from '@shared/config/routes';
import type { OrderView } from '@entities/order';
import { UserCell } from '@entities/user-directory';
import { OrderStatusChip } from './order-status-chip';

export function OrdersTable({ data }: { data: OrderView[] }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const columns: Column<OrderView>[] = [
    {
      key: 'id',
      header: t('orders.columns.id'),
      cell: (o) => <span className="font-mono text-xs">{o.id.slice(0, 8)}</span>,
      width: '120px',
    },
    {
      key: 'title',
      header: t('orders.columns.title'),
      cell: (o) => o.title,
    },
    {
      key: 'buyer',
      header: t('orders.columns.buyer'),
      cell: (o) => <UserCell userId={o.buyerId} user={o.buyer} />,
    },
    {
      key: 'total',
      header: t('orders.columns.total'),
      cell: (o) => <MoneyDisplay money={o.totalAmount} />,
    },
    {
      key: 'status',
      header: t('common.status'),
      cell: (o) => <OrderStatusChip status={o.status} />,
    },
    {
      key: 'updated',
      header: t('orders.columns.updated'),
      cell: (o) => new Date(o.updatedAt).toLocaleDateString(),
    },
  ];

  return (
    <DataTable
      data={data}
      columns={columns}
      rowKey={(o) => o.id}
      onRowClick={(o) => navigate(ROUTES.orderDetail(o.id))}
    />
  );
}
